import FindFolderResponseMessage from 'owa-service/lib/contract/FindFolderResponseMessage';
import findFoldersCountsOnly from 'owa-mail-store/lib/services/findFoldersCountsOnly';
import Folder from 'owa-service/lib/contract/Folder';
import HierarchyNotificationPayload from 'owa-service/lib/contract/HierarchyNotificationPayload';
import NotificationPayloadBase from 'owa-service/lib/contract/NotificationPayloadBase';
import updateFolderCounts from 'owa-mail-actions/lib/updateFolderCounts';
import { lazySubscribe, NotificationSubscription } from 'owa-notification';
import { trace } from 'owa-trace';
import { lazyOnCalendarNotification } from 'owa-upnext';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyOnBulkActionHierarchyNotification } from 'owa-bulk-action-store';

function onHierarchyNotificationCallback(notification: NotificationPayloadBase): void {
    switch (notification.EventType) {
        case 'Reload':
        case 'QueryResultChanged':
            updateFoldersCounts();
            break;
        case 'RowAdded':
        case 'RowModified':
            const hierarchyNotification: HierarchyNotificationPayload = notification;
            updateFolderCounts(
                hierarchyNotification.unreadCount,
                hierarchyNotification.itemCount,
                hierarchyNotification.folderId,
                false /* isDeltaChange */
            );
            lazyOnBulkActionHierarchyNotification
                .import()
                .then(onBulkActionHierarchyNotification => {
                    onBulkActionHierarchyNotification(notification);
                });
            if (
                hierarchyNotification.FolderType == 'CalendarFolder' &&
                isFeatureEnabled('tri-upNext')
            ) {
                lazyOnCalendarNotification.import().then(onCalendarNotification => {
                    onCalendarNotification(notification);
                });
            }
            break;
        default:
            return;
    }
}

export default function subscribeToHierarchyNotification(): void {
    const subscription: NotificationSubscription = {
        subscriptionId: 'HierarchyNotification',
        requiresExplicitSubscribe: true,
        subscriptionParameters: {
            NotificationType: 'HierarchyNotification',
        },
    };

    lazySubscribe.importAndExecute(subscription, onHierarchyNotificationCallback);
}

// update total and unread count for all folders
async function updateFoldersCounts(): Promise<void> {
    const response: FindFolderResponseMessage = await findFoldersCountsOnly();

    if (response.ResponseClass == 'Success') {
        response.RootFolder.Folders.forEach((folder: Folder) => {
            updateFolderCounts(
                folder.UnreadCount,
                folder.TotalCount,
                folder.FolderId.Id,
                false /* isDeltaChange */
            );
        });
    } else {
        trace.warn('UpdateFolderCountsAction failed');
    }
}
